import type { FunctionComponent } from 'react'
import { Fragment } from 'react'
import type { Slide } from '../AccentroSlider'
import { ActiveSlide } from './ActiveSlide'
import { ContentSlide } from './ContentSlide'

export type AccentroSlideProps = {
  onClick?: () => void
  height?: number
  minHeight?: number
  isLexiconSlider?: boolean
  width?: number
  slides: Slide[]
}

export const LexiconSlides: FunctionComponent<
  React.PropsWithChildren<AccentroSlideProps>
> = ({ slides, minHeight }) => {
  return (
    <>
      {slides.map((slide, index) => {
        return (
          <Fragment key={index}>
            {slide.active ? (
              <ActiveSlide slide={slide} minHeight={minHeight} />
            ) : (
              <ContentSlide slide={slide} minHeight={minHeight} />
            )}
          </Fragment>
        )
      })}
    </>
  )
}
